import './redesigns.css'

/**
 * The design's loading state - a drop-in for `components/shared/Loading`'s
 * default (non-"cover") variant on the asset frontend's new-design rendering
 * paths. A couple of call sites (`AssetViewDesign`'s own pending state) render
 * before `AssetShell` has mounted, so this cannot assume the `--rda-*` theme
 * block is in scope: the ring reads `--rda-accent-text` / `--rda-hairline`
 * with the same literal fallbacks `RdaDrawer`/`RdaToast` use, which happen to
 * match `theme.ts`'s own fallback accent (`#002EFF`) - themed when a page has
 * already set the variables, a calm brand blue when it has not.
 */
export default function RdaLoading({
  loading = true,
  /** For a loading state inside an already-sized block (a card, a status
   * panel) rather than one standing in for a whole page/drawer body. */
  compact = false,
  className = '',
}: {
  loading?: boolean
  compact?: boolean
  className?: string
}) {
  if (!loading) return null

  return (
    <div
      role="status"
      aria-label="Loading"
      className={
        'flex w-full items-center justify-center ' +
        (compact ? 'py-6' : 'h-full min-h-[40vh]') +
        ' ' + className
      }
    >
      <span aria-hidden className="rda-spinner" />
    </div>
  )
}
